import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import houseX2Image from '../../assets/images/events/riwaaz/x2.jpeg';
import './EventPopup.css';

const POPUP_SESSION_KEY = 'srk_event_popup_shown';

const EventPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  useEffect(() => {
    if (isAdminRoute) return;

    let alreadyShown = false;
    try {
      alreadyShown = sessionStorage.getItem(POPUP_SESSION_KEY) === 'true';
    } catch (storageError) {
      alreadyShown = false;
    }

    if (alreadyShown) return;

    const timer = setTimeout(() => {
      setIsVisible(true);
      try {
        sessionStorage.setItem(POPUP_SESSION_KEY, 'true');
      } catch (storageError) {
        // ignore write failures (e.g. private browsing)
      }
    }, 800);

    return () => clearTimeout(timer);
    // Intentionally run only once on mount, using the route present at launch.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closePopup = () => setIsVisible(false);

  if (!isVisible) return null;

  return (
    <div className="event-popup-backdrop" onClick={closePopup}>
      <div className="event-popup-card" onClick={(e) => e.stopPropagation()}>
        <button
          type="button"
          className="event-popup-close"
          aria-label="Close"
          onClick={closePopup}
        >
          &times;
        </button>

        <img src={houseX2Image} alt="HOUSE X²" className="event-popup-image" />

        <div className="event-popup-body">
          <span className="badge event-popup-badge px-3 py-2 rounded-pill">
            Event of the Month
          </span>
          <h3 className="event-popup-title">HOUSE X²: OTT Reality Show</h3>
          <p className="event-popup-tagline">One House. Infinite Challenges.</p>
          <p className="event-popup-text">
            Contestants live together in a luxury villa, competing in physical,
            mental, social and entertainment based challenges until the Grand
            Finale.
          </p>

          <div className="event-popup-highlights">
            <div className="event-popup-chip">
              <span className="event-popup-chip-icon">🎬</span>
              <span className="event-popup-chip-label">Age 18+</span>
            </div>
            <div className="event-popup-chip">
              <span className="event-popup-chip-icon">🗓️</span>
              <span className="event-popup-chip-label">8–10 Days</span>
            </div>
            <div className="event-popup-chip">
              <span className="event-popup-chip-icon">📍</span>
              <span className="event-popup-chip-label">Mumbai &amp; Goa</span>
            </div>
            <div className="event-popup-chip">
              <span className="event-popup-chip-icon">🏆</span>
              <span className="event-popup-chip-label">Grand Finale Trophy</span>
            </div>
          </div>
        </div>

        <div className="event-popup-footer">
          <Link
            to="/registration"
            className="btn event-popup-cta btn-lg w-100 rounded-pill fw-bold"
            onClick={closePopup}
          >
            Register Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EventPopup;
